<template>
  <v-card class=" text-center" flat tile>
    <span
      v-html="
        formatNumber({
          num: Articulo[0].EnTransito,
          univenta: Articulo[0].UniVenta,
        })
      "
  /></v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["Articulo"]),
  },
  methods: {
    formatNumber({ num, univenta }) {
      let numeral = require("numeral");
      const formatNum = univenta !== "M2" ? "0,0" : "0,0.00";
      const result = numeral(num).format(formatNum);
      return result;
    },
  },
};
</script>

<style></style>
